import { JsonSerializable } from '@/util/object/JsonSerializable'

export class ItemAttributeResponse extends JsonSerializable {
  /** @type {string} */
  #name
  /** @type {string} */
  #displayName
  /** @type {string} */
  #description

  constructor (jsonObject) {
    super()
    this.#name = jsonObject.name
    this.#displayName = jsonObject.displayName
    this.#description = jsonObject.description
    Object.freeze(this)
  }

  /**
   * @return {string}
   */
  get name () {
    return this.#name
  }

  /**
   * @return {string}
   */
  get displayName () {
    return this.#displayName
  }

  /**
   * @return {string}
   */
  get description () {
    return this.#description
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return {
      name: this.#name,
      displayName: this.#displayName,
      description: this.#description
    }
  }

  /**
   * @param {Object} jsonObject
   * @return {ItemAttributeResponse|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new ItemAttributeResponse(jsonObject)) || undefined
  }
}
